import { Box, IconButton } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Cell } from 'react-table';
import {
  configureOutlookCalendarAccount,
  getConfiguredOutlookCalendarAccounts,
  deleteConfiguredOutlookCalendarAccounts,
  ICalendarDTO,
} from 'wisestep-api';
import { WsIconDelete, OutlookExtensionLogo } from 'wisestep-base';

import { warning, success } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import AccountConfigLayout from '../components/AccountConfigLayout';
import AccountConfiguration from '../components/AccountConfiguration';

const MicrosoftCalenderAccounts = () => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [configuredCalendarAccounts, setConfiguredCalendarAccounts] = useState<ICalendarDTO[]>([]);
  const location = useLocation();
  useEffect(() => {
    (async function () {
      const getCalendarAccounts = await getConfiguredOutlookCalendarAccounts();
      if (getCalendarAccounts.data) setConfiguredCalendarAccounts(getCalendarAccounts.data);
    })();
  }, []);

  const onDelete = async (index: number) => {
    const toDelete: ICalendarDTO = configuredCalendarAccounts[index];
    const scopes = toDelete.scope.split(' ');
    const indexOfCalendarScope = scopes.indexOf('Calendars.ReadWrite');
    scopes.splice(indexOfCalendarScope, 1);
    toDelete.scope = scopes.join(' ');
    try {
      await deleteConfiguredOutlookCalendarAccounts(toDelete);
      const getCalendarAccounts = await getConfiguredOutlookCalendarAccounts();
      if (getCalendarAccounts.data) setConfiguredCalendarAccounts(getCalendarAccounts.data);
      setNotification(success('Deleted Successfully'));
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };
  const onSaveHandler = async () => {
    try {
      const res = await configureOutlookCalendarAccount();
      window.location.href = res.data.url;
    } catch (error) {
      setNotification(warning('Something Went Wrong , Please try again'));
    }
  };

  const outlookColumns = [
    {
      Header: 'Account Name',
      accessor: 'account_name',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: (cell: Cell) => (
        <IconButton onClick={() => onDelete(cell.row.index)}>
          <WsIconDelete />
        </IconButton>
      ),
    },
  ];

  const outlookData = useMemo(
    () =>
      configuredCalendarAccounts?.map((accountsList) => ({
        account_name: accountsList.email,
      })),
    [configuredCalendarAccounts]
  );
  return (
    <AccountConfigLayout title={'Calender'}>
      <Box component="form" display={'flex'}>
        {location.pathname === '/calender-settings/microsoft' && (
          <AccountConfiguration
            buttonCallBack={() => onSaveHandler()}
            accName={'Microsoft'}
            columns={outlookColumns}
            data={outlookData}
            icon={<OutlookExtensionLogo />}
            deleteAccount={(index) => onDelete(index)}
          />
        )}
      </Box>
    </AccountConfigLayout>
  );
};

export default MicrosoftCalenderAccounts;
